import {useTranslationContext} from 'platform/components';
import {Show} from 'platform/foundation';

import type {ReactNode} from 'react';

function SettingsGearIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      style={{color: '#7A869A'}}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 13a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.2a1.6 1.6 0 0 0-2.7-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0-1.1-2.7H3a2 2 0 1 1 0-4h.2a1.6 1.6 0 0 0 1.1-2.7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 2.7-1.1V3a2 2 0 1 1 4 0v.2a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7H21a2 2 0 1 1 0 4h-.2a1.6 1.6 0 0 0-1.4 1z" />
      </g>
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="6" y1="6" x2="18" y2="18" />
        <line x1="18" y1="6" x2="6" y2="18" />
      </g>
    </svg>
  );
}

export type SidebarPanelHeaderBadge = {
  count: number;
  testId: string;
};

export type SidebarPanelHeaderProps = {
  title: string;
  leadingIcon?: ReactNode;
  badge: SidebarPanelHeaderBadge | undefined;
  onClose: () => void;
};

export function SidebarPanelHeader(props: SidebarPanelHeaderProps) {
  const t = useTranslationContext();

  return (
    <div
      className="flex items-center justify-between px-4 pt-3.5 pb-3 flex-shrink-0"
      style={{borderBottom: '1px solid #EBECF0'}}
    >
      <span className="inline-flex items-center gap-2">
        {props.leadingIcon}
        <span style={{fontSize: '15px', fontWeight: 500}} data-testid="sidebar-panel-title">
          {props.title}
        </span>
        <Show when={props.badge != null && props.badge.count > 0 ? props.badge : null}>
          {(badge) => (
            <span
              className="inline-flex items-center justify-center rounded-full bg-[#0065FF] text-white"
              style={{
                fontSize: '11px',
                fontWeight: 700,
                minWidth: '18px',
                height: '18px',
                padding: '0 5px',
                fontVariantNumeric: 'tabular-nums',
              }}
              data-testid={badge.testId}
            >
              {badge.count}
            </span>
          )}
        </Show>
      </span>
      <button
        type="button"
        aria-label={t('page.datagrid.button.close')}
        onClick={props.onClose}
        className="inline-flex items-center justify-center rounded-[4px] border-0 bg-transparent cursor-pointer hover:bg-[#F4F5F7]"
        style={{width: '34px', height: '34px', color: '#42526E'}}
      >
        <CloseIcon />
      </button>
    </div>
  );
}

export {SettingsGearIcon};
